export default __webpack_public_path__ + "static/media/Memoria Gama 2022.21e91a37.pdf";